import React from 'react';
import { DialogProps, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DialogCustom from './DialogCustom';

const DialogImg = ({
  imgSrc,
  desc,
  open,
  onClose,
  maxWidth = 400,
  maxHeight = 550,
  hideActions = true,
  sx = {},
}) => {
  if (!imgSrc) return null;

  return (
    <DialogCustom
      isOpen={open}
      onClose={onClose}
      hideActions={hideActions}
      sx={{
        '& .css-1t1j96h-MuiPaper-root-MuiDialog-paper': {
          margin: 2,
          minWidth:maxWidth,
          minHeight:maxHeight,
        },
        ...sx,
      }}
    >
      <Typography variant="h6" sx={{ position: 'absolute', mt: 0.2 }}>
        {desc}
      </Typography>
      <IconButton
        sx={{ float: 'right', mt: -1 }}
        onClick={() => onClose(false)}
      >
        <CloseIcon />
      </IconButton>
      <Box sx={{ justifyContent: 'center', alignItems: 'center', display:'flex', mt:6}}>
        <Box
          component="img"
          src={imgSrc}
          sx={{
            width: maxWidth,
            maxWidth,
            maxHeight,
          }}
        />
      </Box>
    </DialogCustom>
  );
};

export default DialogImg;
